import authReducer from './authReducer';
import { firestoreReducer } from 'redux-firestore'; //A premade reducer which is used to sync the redux with firestore database in the background.
import { firebaseReducer } from 'react-redux-firebase'; //Used for Firebase Authentication.
import toggleBooleanFormsReducer from './toggleBooleanFormsReducer';
import toggleEditContentReducer from './toggleEditContentReducer';
import PublishCoursesReducer from './publishCoursesReducer';
import marketplaceSelectedCourseReducer from './marketplaceReducer'
import algorithmReducer from './algorithmReducer';
import createCourseReducer from './createCourseReducer';
import highlightContentReducer from './highlightContentReducer';
import createLectureReducer from './createLectureReducer';
import createQuestionReducer from './createQuestionReducer';
import publishCourseReducer from './publishCourseReducer';
import videoReducer from './videoReducer';
import footerReducer from './footerReducer';
import dashboardReducer from './dashboardReducer';
import publishReducer from './publishReducer';
import homepageReducer from './homepageReducer';
import feedbackReducer from './feedbackReducer';
import settingsReducer from './settingsReducer';
import triggerReducer from './triggerReducer';
import AdminPanelReducer from './AdminPanelReducer';

// Define the reducers that will always be present in the application
const staticReducers = {
    FeedbackReducer: feedbackReducer,
    PublishReducer: publishReducer,
    DashboardReducer: dashboardReducer,
    VideoModal: videoReducer,
    FooterReducer: footerReducer,
    CourseDisplayModals: createCourseReducer,
    LectureDisplayModals: createLectureReducer,
    QuestionDisplayModals: createQuestionReducer,
    publishCourseReducer: publishCourseReducer,
    auth: authReducer,
    homepageReducer: homepageReducer,
    Marketplace: marketplaceSelectedCourseReducer,
    algorithm: algorithmReducer,
    highlightContent: highlightContentReducer,
    ToggleBooleanForms: toggleBooleanFormsReducer,
    ToggleEditContent: toggleEditContentReducer,
    PublishCoursesContent: PublishCoursesReducer,
    firestore: firestoreReducer, 
    firebase: firebaseReducer,
    settingsReducer: settingsReducer,
    triggerReducer: triggerReducer,
    AdminPanelReducer: AdminPanelReducer,
  };

export default staticReducers